import { CategoryImpact } from 'app/model/redshift/impact-report/category-impact';
import { ChannelImpact } from 'app/model/redshift/impact-report/channel-impact';
import { StoreImpact } from 'app/model/redshift/impact-report/store-impact';
import { RestfulApiService } from 'app/services/restful-api.service';

class ImpactReportService extends RestfulApiService<CategoryImpact | ChannelImpact | StoreImpact> {
    protected getFormName(): string {
        return 'impact_report';
    }

    protected getPath(): string {
        return 'qa/impact';
    }
}

export const impactReportService = new ImpactReportService();
